import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
const ACTION_LABELS = {
    keep: 'Добавить',
    delete: 'Удалить',
    defer: 'Отложить',
};
const ACTION_STYLES = {
    keep: 'legacy-action-keep',
    delete: 'legacy-action-delete',
    defer: 'legacy-action-defer',
};
export default function LegacyMigrationPage({ budgets, loading, onConfirm, }) {
    const [actions, setActions] = useState(() => {
        const init = {};
        for (const b of budgets) {
            init[b.id] = 'keep';
        }
        return init;
    });
    function cycleAction(id) {
        setActions((prev) => {
            const order = ['keep', 'delete', 'defer'];
            const cur = prev[id] ?? 'keep';
            const next = order[(order.indexOf(cur) + 1) % order.length];
            return { ...prev, [id]: next };
        });
    }
    function setAllAction(action) {
        setActions((prev) => {
            const next = { ...prev };
            for (const id in next) {
                next[id] = action;
            }
            return next;
        });
    }
    function handleConfirm() {
        const decisions = budgets.map((b) => ({
            budgetId: b.id,
            action: actions[b.id] ?? 'keep',
        }));
        onConfirm(decisions);
    }
    return (_jsx("div", { className: "legacy-page", children: _jsxs("div", { className: "legacy-container", children: [_jsx("h1", { className: "legacy-title", children: "\u041D\u0430\u0439\u0434\u0435\u043D\u044B \u043B\u043E\u043A\u0430\u043B\u044C\u043D\u044B\u0435 \u0431\u044E\u0434\u0436\u0435\u0442\u044B" }), _jsx("p", { className: "legacy-subtitle", children: "\u041D\u0430 \u044D\u0442\u043E\u043C \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0435 \u043E\u0431\u043D\u0430\u0440\u0443\u0436\u0435\u043D\u044B \u0431\u044E\u0434\u0436\u0435\u0442\u044B, \u0441\u043E\u0437\u0434\u0430\u043D\u043D\u044B\u0435 \u0434\u043E \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u0438. \u0414\u043B\u044F \u043A\u0430\u0436\u0434\u043E\u0433\u043E \u0431\u044E\u0434\u0436\u0435\u0442\u0430 \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435:" }), _jsxs("div", { className: "legacy-bulk-actions", children: [_jsx("span", { className: "legacy-bulk-label", children: "\u0414\u043B\u044F \u0432\u0441\u0435\u0445:" }), _jsx("button", { className: "legacy-bulk-btn", onClick: () => setAllAction('keep'), children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C" }), _jsx("button", { className: "legacy-bulk-btn", onClick: () => setAllAction('delete'), children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C" }), _jsx("button", { className: "legacy-bulk-btn", onClick: () => setAllAction('defer'), children: "\u041E\u0442\u043B\u043E\u0436\u0438\u0442\u044C" })] }), _jsx("div", { className: "legacy-budget-list", children: budgets.map((b) => {
                        const action = actions[b.id] ?? 'keep';
                        return (_jsxs("div", { className: "legacy-budget-item", children: [_jsx("span", { className: "legacy-budget-icon", children: b.icon }), _jsxs("div", { className: "legacy-budget-info", children: [_jsx("span", { className: "legacy-budget-name", children: b.name }), _jsxs("span", { className: "legacy-budget-meta", children: [b.currency, " \u00B7 ", b.transactions.length, " \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0439"] })] }), _jsx("button", { className: `legacy-action-btn ${ACTION_STYLES[action]}`, onClick: () => cycleAction(b.id), children: ACTION_LABELS[action] })] }, b.id));
                    }) }), _jsx("button", { className: "legacy-confirm-btn", disabled: loading, onClick: handleConfirm, children: loading ? 'Обработка...' : 'Подтвердить' })] }) }));
}
